import {Action, props } from '@ngrx/store';
import { IAppliedDiscount, ICart, IAdditionalDeliveryInfo, ICartLoadOptions } from '../models/cart/i-cart';
import { ICartLine } from '../models/cart/i-cart-line';
import { IBakery } from '@cakeiteasy/web-utils';

// load pizzas
const prefix = '[CART] ';

export const RESET_CART = prefix + 'Reset Cart';
export const LOAD_CART = prefix + 'Load Cart';
export const LOAD_CART_FAIL = prefix + 'Load Cart Fail';
export const LOAD_CART_SUCCESS = prefix + 'Load Cart Success';
export const ADD_LINE = prefix + 'Add Line';
export const APPLY_PROMO = prefix + 'Apply company promo';
export const CANCEL_PROMO = prefix + 'Cancel company promo';
export const APPLY_INVOICE_FEE = prefix + 'Apply Invoice Fee';
export const CANCEL_INVOICE_FEE = prefix + 'Cancel Invoice Fee';
export const APPLY_DELIVERY_DEPOSIT = prefix + 'Apply Delivery Deposit';
export const REMOVE_LINE = prefix + 'Remove line';
export const UPDATE_LINE = prefix + 'Update line';
export const SET_DELIVERY_ACTIVE_STATUS = prefix + 'Set delivery active status';
export const SET_DELIVERY = prefix + 'Set delivery';
export const DELIVERY_INFO_UPDATE = prefix + 'Delivery info update';
export const SET_BAKERY = prefix + 'Set bakery';
export const CART_TOTAL_PRICE_ZERO_CHANGED = prefix + 'Cart total price zero changed';

export class ResetCart implements Action {
  readonly type = RESET_CART;
}

export class LoadCart implements Action {
  readonly type = LOAD_CART;

  constructor(public payload?: ICartLoadOptions) {
  }
}

export class LoadCartFail implements Action {
  readonly type = LOAD_CART_FAIL;

  constructor(public payload: any) {
  }
}

export class LoadCartSuccess implements Action {
  readonly type = LOAD_CART_SUCCESS;

  constructor(public payload: ICart) {
  }
}

export class AddLine implements Action {
  readonly type = ADD_LINE;

  constructor(public line: ICartLine) {
  }
}

export class UpdateLine implements Action {
  readonly type = UPDATE_LINE;

  constructor(public line: ICartLine) {
  }
}

export class RemoveLine implements Action {
  readonly type = REMOVE_LINE;

  constructor(public clientId: string) {
  }
}

export class ApplyPromo implements Action {
  readonly type = APPLY_PROMO;

  constructor(public appliedDiscount: IAppliedDiscount) {
  }
}

export class CancelPromo implements Action {
  readonly type = CANCEL_PROMO;

  constructor() {
  }
}

export class ApplyInvoiceFee implements Action {
  readonly type = APPLY_INVOICE_FEE;

  constructor(public payload: number) {
  }
}

export class ApplyDeliveryDeposit implements Action {
  readonly type = APPLY_DELIVERY_DEPOSIT;

  constructor() {
  }
}

export class CancelInvoiceFee implements Action {
  readonly type = CANCEL_INVOICE_FEE;

  constructor() {
  }
}

export class SetDeliveryActiveStatus implements Action {
  readonly type = SET_DELIVERY_ACTIVE_STATUS;

  constructor(public payload: boolean) {
  }
}

export class SetBakery implements Action {
  readonly type = SET_BAKERY;

  constructor(public payload: IBakery) {
  }
}

export class DeliveryInfoUpdate implements Action {
  readonly type = DELIVERY_INFO_UPDATE;

  constructor(public payload: IAdditionalDeliveryInfo) {
  }
}

export class SetDelivery implements Action {
  readonly type = SET_DELIVERY;

  constructor(public payload: any) {
  }
}

// action types
export type CartAction =
  | AddLine
  | UpdateLine
  | RemoveLine
  | LoadCart
  | ResetCart
  | LoadCartFail
  | LoadCartSuccess
  | ApplyPromo
  | ApplyInvoiceFee
  | SetDeliveryActiveStatus
  | SetBakery
  | DeliveryInfoUpdate;
